var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlacehoder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 217,
    viewBox: "0 0 440 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 217,
    rx: 8,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.167 65.6667H165.833V152.333H274.167V65.6667ZM209.167 87.3334C212.157 87.3334 214.583 89.76 214.583 92.75C214.583 95.74 212.157 98.1667 209.167 98.1667C206.177 98.1667 203.75 95.74 203.75 92.75C203.75 89.76 206.177 87.3334 209.167 87.3334ZM257.917 136.083H182.083L201.036 111.714L214.583 128.013L233.542 103.589L257.917 136.083Z",
    fill: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlacehoder);
export default __webpack_public_path__ + "static/media/imagePlacehoder.29024ccdb2948549233f13664b8fbdb1.svg";
export { ForwardRef as ReactComponent };